import React from 'react';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import useProcessInstanceService from 'domain/gpo/cockpit/instance/processInstanceService';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import RedmineIssueField from 'infrastructure/integrations/redmine/RedmineIssueField';
import { FullDateField, TextField } from 'framework/ui/field';
import RedmineUserField from 'infrastructure/integrations/redmine/RedmineUserField';
import CloseIssueButton from 'domain/gpo/cockpit/instance/Show/issues/shared/button/CloseIssueButton';
import CopyActivityInstanceIdButton from 'domain/gpo/cockpit/instance/Show/issues/shared/button/CopyActivityInstanceIdButton';

const IssuesTable = () => {
  const id = useProcessInstanceId();
  const { getProcessIssues } = useProcessInstanceService();

  const getDataMethod = async () => {
    const issues = await getProcessIssues(id);
    return issues;
  };

  return (
    <RelatedList getDataMethod={getDataMethod}>
      <RelationListLayout header="User Tasks" actions={[]}>
        <DataGridLayout
          showTotal={false}
          buttons={[
            <CopyActivityInstanceIdButton sourceExecutionId="activityInstanceId" />,
            <CloseIssueButton sourceIssueId="id" />,
          ]}
          isSmallTable
        >
          <RedmineIssueField source="id" />
          <TextField source="subject" />
          <RedmineUserField label="Assignee" nameSource="assignee.name" source="assignee.id" />
          <FullDateField label="Created at" source="createdAt" />
          <FullDateField label="Closed at" source="closedAt" />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedList>
  );
};

export default IssuesTable;
